import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { timer } from 'rxjs'

import { advanceTurn } from '../../../redux/actions/game/activeTime.actions'
import getBattleData from '../../../redux/selectors/getBattleData'

const TurnCounter = (props) => {
    const { advance, activeTime: { turn /* , status */ }, battleData: { currentStatus } } = props
    useEffect(() => {
        const battleTimer = timer(1000, 2000)
        const tickSubscription = battleTimer.subscribe((tick) => {
            if (currentStatus === 'active') {
                advance(tick)
            }
        })
        return () => {
            tickSubscription.unsubscribe()
        }
    }, [advance, currentStatus])

    // const statusIcon = status === 'running' ? '⏩' : '⏹'

    return (
        <div className="turnCounter">
            <div>
                {`${turn + 1}`}
            </div>
            {/* `Status: ${statusIcon}` */}
        </div>
    )
}

TurnCounter.propTypes = {
    activeTime: PropTypes.object.isRequired,
    battleData: PropTypes.object.isRequired,
    advance: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    activeTime: state.activeTime,
    battleData: getBattleData(state),
})

const mapDispatchToProps = dispatch => ({
    advance: (tick) => {
        dispatch(advanceTurn(tick))
    },
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TurnCounter)
